import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { di } from 'react-magnetic-di';
import { useEditorStateHasJqlError, useExternalMessages, useJqlError } from '../../state';

/**
 * Determine if the editor view should be displayed in an invalid state. To determine if the editor is invalid we adopt
 * the following rules:
 * 1. Client errors are dynamic
 *    a. If the user searches with invalid JQL then the invalid state is shown
 *    b. If the user fixes the error the invalid state is cleared until their next search
 * 2. External JQL errors are static
 *    a. If an external error is provided (and the previous search contains no client errors) then the invalid state is
 *    shown until their next search
 */
export var useEditorViewIsInvalid = function useEditorViewIsInvalid() {
  var _useJqlError = useJqlError(),
    _useJqlError2 = _slicedToArray(_useJqlError, 1),
    jqlError = _useJqlError2[0];
  var _useExternalMessages = useExternalMessages(),
    _useExternalMessages2 = _slicedToArray(_useExternalMessages, 1),
    externalErrors = _useExternalMessages2[0].errors;
  var _useEditorStateHasJql = useEditorStateHasJqlError(),
    _useEditorStateHasJql2 = _slicedToArray(_useEditorStateHasJql, 1),
    editorStateHasJqlError = _useEditorStateHasJql2[0];

  // Determines if the last searched query contained an error that has not been fixed in the editor
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasActiveError = _useState2[0],
    setHasActiveError = _useState2[1];
  var hasActiveExternalError = jqlError === null && externalErrors.length > 0;

  // Update hasActiveError whenever a query has been searched and the resulting jqlError has changed
  useEffect(function () {
    setHasActiveError(jqlError !== null);
  }, [jqlError]);

  // Set hasActiveError to false whenever the editor JQL is valid
  useEffect(function () {
    if (!editorStateHasJqlError) {
      setHasActiveError(false);
    }
  }, [editorStateHasJqlError]);
  return hasActiveError || hasActiveExternalError;
};